import React, { ComponentType } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import usePopup from '../../../hooks/usePopup';
import FieldPickerPopup from './FieldPickerPopup';
import useModalWidth from '../../../hooks/useModalWidth';

const FieldsPicker = ({
  selectedFields,
  onFieldsConfirmed,
  Button,
  fieldRedList,
  fieldTypeRedList,
  alwaysAllowedFields,
  datasetsGreenList,
  isPerformanceDatasetsAllowed,
  isSaving,
  hideDatasetSidebar,
  showClearButton,
  applyOnChange,
}: {
  selectedFields: {
    dataType: string;
    fields: string[];
  }[];
  onFieldsConfirmed: (
    confirmedFields: { dataType: string; fields: string[] }[],
  ) => void;
  Button: ComponentType<{ onClick: () => void }>;
  fieldRedList?: string[];
  fieldTypeRedList?: FleetOps.FieldType[];
  // Always offered, even when their dataset isn't in datasetsGreenList or
  // their type is in fieldTypeRedList.
  alwaysAllowedFields?: { dataType: string; fields: string[] }[];
  datasetsGreenList?: string[];
  // isPerformanceDatasetsAllowed was added in a rushed context.
  // -> Is there something better we can reach for here?
  isPerformanceDatasetsAllowed?: boolean;
  isSaving?: boolean;
  // Hides the "Filter by Dataset" sidebar (single-dataset use cases).
  hideDatasetSidebar?: boolean;
  // Shows a "Clear all" button that resets the in-popup selection.
  showClearButton?: boolean;
  // Applies changes immediately (no "Confirm Selection" step).
  applyOnChange?: boolean;
}) => {
  const { isOpen, open, close } = usePopup();
  const modalWidth = useModalWidth();

  return (
    <div>
      <Button onClick={open} />
      <ModalTransition>
        {isOpen && (
          <Modal
            onClose={close}
            shouldScrollInViewport={false}
            autoFocus={false}
            width={modalWidth}
          >
            <FieldPickerPopup
              close={close}
              initialFields={selectedFields}
              onFieldsConfirmed={onFieldsConfirmed}
              datasetsGreenList={datasetsGreenList}
              fieldRedList={fieldRedList}
              fieldTypeRedList={fieldTypeRedList}
              alwaysAllowedFields={alwaysAllowedFields}
              isSaving={isSaving}
              isPerformanceDatasetsAllowed={isPerformanceDatasetsAllowed}
              hideDatasetSidebar={hideDatasetSidebar}
              showClearButton={showClearButton}
              applyOnChange={applyOnChange}
            />
          </Modal>
        )}
      </ModalTransition>
    </div>
  );
};

export default FieldsPicker;
